import {Research} from "../const";


const extend = (a, b) => {
  return Object.assign({}, a, b);
};

const getAreaTotalResearches = (area, dataMode) => {
  const totalResearches = [];

  Object.values(Research).forEach((researchItem) => {
    const filterResearches = area.researches.filter((research) => research.name === researchItem && research.dataMode === dataMode);
    const totalAmount = filterResearches.reduce((accumulator, research) => accumulator + research.amount, 0);
    const totalAmountNotMatch = filterResearches.reduce((accumulator, research) => accumulator + research.notMatch, 0);
    const researchSources = area.sources.filter((sourceItem) => sourceItem.name === researchItem && sourceItem.dataMode === dataMode)[0].researchSources || null;
    const isDetails = (filterResearches.length === 1 && filterResearches[0].title === ``) || (totalAmount === 0) ? false : true;

    totalResearches.push({
      name: researchItem,
      totalAmount,
      totalAmountNotMatch,
      researchSources,
      isDetails,
    });
  });

  return totalResearches;
};

const getPoolTotalResearches = (pool, dataMode) => {
  const totalResearches = [];
  const catchAreasResearches = pool.catchAreas.map((area) => getAreaTotalResearches(area, dataMode)).flat();

  Object.values(Research).forEach((researchItem) => {
    const filterResearches = catchAreasResearches.filter((research) => research.name === researchItem);
    const totalAmount = filterResearches.reduce((accumulator, research) => accumulator + research.totalAmount, 0);
    const totalAmountNotMatch = filterResearches.reduce((accumulator, research) => accumulator + research.totalAmountNotMatch, 0);

    totalResearches.push({
      name: researchItem,
      totalAmount,
      totalAmountNotMatch,
    });
  });

  return totalResearches;
};

const getPoolsTotalResearches = (pools, dataMode) => {
  const totalResearches = [];
  const poolsResearches = pools.map((pool) => getPoolTotalResearches(pool, dataMode)).flat();

  Object.values(Research).forEach((researchItem) => {
    const filterResearches = poolsResearches.filter((research) => research.name === researchItem);
    const totalAmount = filterResearches.reduce((accumulator, research) => accumulator + research.totalAmount, 0);
    const totalAmountNotMatch = filterResearches.reduce((accumulator, research) => accumulator + research.totalAmountNotMatch, 0);

    totalResearches.push({
      name: researchItem,
      totalAmount,
      totalAmountNotMatch,
    });
  });

  return totalResearches;
};

const getPoolRegions = (pool) => {
  return Array.from(new Set(pool.catchAreas.map((area) => (area.region))).values());
};

const applyMobileMap = (map) => {
  const isMobile = {
    android() {
      return navigator.userAgent.match(/Android/i);
    },
    blackBerry() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    opera() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    windows() {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any() {
      return (isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.opera() || isMobile.windows());
    }
  };
  if (isMobile.any()) {
    map.behaviors.disable(`drag`);
  }
};

const checkPoolAvailability = (pools, poolId) => {
  return pools.some((pool) => pool.id === poolId);
};


export {
  applyMobileMap,
  checkPoolAvailability,
  extend,
  getAreaTotalResearches,
  getPoolTotalResearches,
  getPoolsTotalResearches,
  getPoolRegions,
};
